export default "__VITE_ASSET__O1x2onYe__"